<template>
    <div class="select-pair">

        <p class="current-pair" @click="show = !show" tabindex="0" @blur="show = false">
            {{ currentPair }}
            <img src="@/assets/images/icons/arrow_down-pink.svg" :class="{'active': show}" alt="arrow down">
        </p>

        <transition name="fade">

            <ul v-show="show" class="pairs-list">

                <li v-for="pair in availablePairs"
                    :key="pair.id"
                    @click="setCurrentPair(pair)"
                    :class="{'active': isCurrentPair(pair)}"
                >

                    <cryptoicon :symbol="pair.split('/')[0]" size="27"></cryptoicon>

                    <p class="crypto">{{ pair.split('/')[0] }} </p>
                    <p class="currency">/ {{ pair.split('/')[1] }}</p>

                    <img src="@/assets/images/icons/check-mark_pink.svg" v-if="isCurrentPair(pair)">

                </li>

            </ul>

        </transition>

    </div>
</template>

<script>
    export default {
        name: "SelectPair",
        props: {
            value: {
                type: String,
                default: ''
            },
            availablePairs: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                show: false,
                currentPair: ''
            }
        },
        methods: {
            setCurrentPair(pair) {
                this.currentPair = pair;
                this.$emit('input', pair)
            },
            isCurrentPair(pair) {
                return this.currentPair === pair
            }
        },
        mounted() {
            this.currentPair = this.value
        }
    }
</script>